
import Vue from 'vue';
import type { Route } from 'vue-router';
import { namespace } from 'vuex-class';
import { Component, Prop, Watch } from 'vue-property-decorator';

const Routing = namespace('routing');

@Component({ name: 'JwTinySwiper' })
export default class JwTinySwiper extends Vue {
	@Prop({ default: () => [] }) items: String[];

	@Routing.State activeRoute: Route;
	@Routing.State lastRoute: Route;

	// as soon as the user interacts with it, more backdrops are loaded instead of just 1
	loadAllBackdrops = false;
	currentSlideIndex = 0;
	swiper: any;
	resizeObserverInstance: ResizeObserver;

	@Watch('activeRoute')
	/**
	 * This function refreshes slider once the active route changes
	 * @return {void}
	 */
	onRouteChange() {
		const lastTitle = this.lastRoute.params.title;
		const currentTitle = this.activeRoute.params.title;

		if (lastTitle != null && lastTitle !== currentTitle && this.swiper) {
			this.update();
		}
	}

	async mounted() {
		await this.initSwiper();
	}

	getSwiperContainerElement(): Element | null {
		return document.querySelector('.swiper-container');
	}

	/**
	 * This function transitions the slider to the specified slide.
	 * @param {number} index the specified slide
	 * @return {void}
	 */
	goToSlide(index: number): void {
		this.swiper.slideTo(index);
	}

	/**
	 * This function changes the index of the slider
	 * @param {string} direction the direction of the slider
	 * @return {void}
	 */
	changeSlideIndex(index: number, nextIndex: number): void {
		this.currentSlideIndex = nextIndex;
		this.loadAllBackdrops = true;

		if (nextIndex !== index) {
			this.$emit('slideChange', {
				label: 'swipe_backdrops',
				action: index < nextIndex ? 'next' : 'prev',
			});
		}
	}

	/**
	 * This function transitions the slider to the next slide
	 * @return {void}
	 */
	next(): void {
		this.swiper.slideTo(this.currentSlideIndex + 1);
	}

	/**
	 * This function transitions to the previous slide.
	 * @return {void}
	 */
	prev(): void {
		this.swiper.slideTo(this.currentSlideIndex - 1);
	}

	/**
	 * This function updates the slider
	 * @return {void}
	 */
	private update(): void {
		this.initSwiper();
		this.swiper.update();
		this.swiper.slideTo(0);
		this.currentSlideIndex = 0;
	}

	async initSwiper(initialSlideIndex: number = 0) {
		const { default: Swiper } = await import('tiny-swiper');

		try {
			const el = document.querySelector('.swiper-container') as HTMLElement;

			if (el) {
				this.swiper = new Swiper('.swiper-container', {
					initialSlide: initialSlideIndex,
				});

				this.swiper.on('before-slide', (current: number, state: any, next: number) =>
					this.changeSlideIndex(current, next)
				);
			}
		} catch (e) {}
	}
}
